import styled from 'styled-components';

import Colors from '@/v2/constants/Colors';

export const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 24px;
  white-space: nowrap;

  > a:focus-visible {
    outline: 2px solid ${Colors.BLUE};
    outline-offset: 4px;
  }
`;
